import { MASS_TIMES } from "@/lib/constants";
import { TIDS } from "@/constants/testIds";

const Section = ({ title, children, accent }) => (
    <div className="rounded-2xl border border-maroon-100 bg-cream-50 p-6 shadow-sm">
        <div className="flex items-center gap-3">
            <div className={`h-2 w-2 rounded-full ${accent || "bg-gold-400"}`} />
            <h4 className="font-serif text-xl text-maroon-800">{title}</h4>
        </div>
        <div className="gold-divider my-3 opacity-50" />
        {children}
    </div>
);

const Row = ({ time, note }) => (
    <div className="mass-row">
        <div className="font-serif text-2xl text-maroon-800 tabular-nums">{time}</div>
        <div className="text-sm text-maroon-700/85">{note}</div>
    </div>
);

const MassTimes = ({ compact = false }) => {
    return (
        <div data-testid={TIDS.home.massTimes} className={`grid gap-5 ${compact ? "" : "md:grid-cols-2 xl:grid-cols-4"}`}>
            <Section title="Weekdays">
                {MASS_TIMES.weekdays.times.map((t) => (
                    <Row key={t.time} {...t} />
                ))}
            </Section>

            <Section title="Saturday" accent="bg-maroon-600">
                {MASS_TIMES.saturday.times.map((t) => (
                    <Row key={t.time} {...t} />
                ))}
            </Section>

            <Section title="Sunday" accent="bg-gold-400">
                {MASS_TIMES.sunday.times.map((t) => (
                    <Row key={t.time} {...t} />
                ))}
            </Section>

            <Section title="Public Holidays" accent="bg-gold-600">
                {MASS_TIMES.publicHolidays.times.map((t) => (
                    <Row key={t.time} {...t} />
                ))}
            </Section>
        </div>
    );
};

export default MassTimes;
